<template>
  <div>
    <!--部门数据-->
    <el-col>
      <div class="head-container" style="margin-bottom: 50px">
      </div>
      <div id="supplierList" class="head-container">
        <el-card class="box-card">
          <el-tree :data="options" :props="defaultProps" highlight-current default-expand-all @node-click="handleNodeClick"></el-tree>
        </el-card>
      </div>
    </el-col>
  </div>
</template>

<script>
import api from '@/api/system/dict_type' // 和数据交互相关写在api 方便复用

export default {
  name: 'SelectDictType',
  props: {
    type: {
      type: String,
      default: '全部'
    }
  },
  data() {
    return {
      api,
      options: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 点击选中的索引
      clickIndex: 0,
      pid: 0
    }
  },
  created() {
    this.api.Query({ sort: 'id', order: 'desc', isPaginator: false, status: 1 }).then(response => {
      this.options = JSON.parse(JSON.stringify(response.data))
    })
  },
  methods: {
    // 节点单击事件
    handleNodeClick(data, index) {
      this.clickIndex = index
      this.$emit('input', data.id)
      this.$emit('setCode', data)
      this.$emit('change')
    }
  }
}
</script>

  <style scoped>
  #supplierList:hover {
    cursor: pointer;
  }
  .supplier {
    border-bottom: 1px solid #d4d4d4;
    margin-bottom: 10px;
  }
   .backColor{
    background-color: #00afff;
  }
  </style>
